module.exports = __webpack_public_path__ + "static/photography-094c15650761b14bb08850487ae2a07c.jpg";